module.exports = __webpack_public_path__ + "static/FSD-2-4fc973c26e38b1ead0410942e9a89d69.jpg";